import { Box, Grid, Typography, Avatar } from '@mui/material';
import moment from 'moment';
import NoDataImg from '../../../../../Components/NoDataFound/NoDataFound';
import Skeleton from 'react-loading-skeleton';
import { Chip } from '@mui/material';
import { styled } from '@mui/system';
const ReferralCard = styled(Box)(({ theme }) => ({
    width: '100%',
    background: "#FAFAFA",
    border: "1px solid #08557F33",
    padding: '15px',
    borderRadius: '15px',
    marginBottom: '15px',
    '&:hover': {
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    },
}));

const ReferralsDetails = (props) => {
    const { referralList, isLoading, userName } = props;

    const getStatusLabel = (status) => {
        switch (status) {
            case 1: return 'Completed';
            default: return 'Pending';
        }
    };

    return (
        <Box sx={{
            width: '100%',
            padding: '0px 10px 0px 10px',
            height: 'calc(100vh - 210px)',
            overflowY: 'auto',
        }}>
            {/* Show referring user name */}
            {userName && (
                <Typography variant="h6" sx={{ mb: 2, fontWeight: '600', fontFamily: 'Outfit' }}>
                    Referrals by {userName}
                </Typography>
            )}

            <Grid container spacing={2} height={
                referralList && referralList?.length > 0 ? "auto" : "100%"
            }>
                {isLoading ? (
                    [...Array(5)].map((_, index) => (
                        <Grid item xs={12} key={index}>
                            <Skeleton variant="rectangular" height={120} borderRadius={15} />
                        </Grid>
                    ))
                ) : referralList?.length > 0 ? referralList.map((referral, index) => (
                    <Grid item xs={12} key={index}>
                        <ReferralCard>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <Box display="flex" alignItems="center">
                                    <Avatar
                                        src={referral.refer_to_details?.profile_img || ''}
                                        alt={referral.refer_to_details?.full_name}
                                        sx={{ width: 40, height: 40, mr: 2 }}
                                    />
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                color: "rgba(40, 29, 27, 1)",
                                                fontFamily: "Outfit",
                                            }}
                                        >
                                            {referral.refer_to_details?.full_name || 'Unknown User'}
                                        </Typography>
                                        <Typography sx={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "rgba(8, 85, 127, 1)",
                                            textAlign: "left",
                                            textTransform: "capitalize",
                                            fontFamily: "Outfit"
                                        }}>
                                            Referred on {moment(referral.created_at).format('DD MMM YYYY')}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Chip
                                    label={`+${referral.coin} coins`}
                                    color="success"
                                    size="small"
                                    sx={{ fontWeight: 'bold' }}
                                />
                            </Box>

                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Chip
                                    label={getStatusLabel(referral.status)}
                                    color={referral.status === 1 ? 'primary' : 'default'}
                                    size="small"
                                />
                            </Box>
                        </ReferralCard>
                    </Grid>
                )) : (
                    <Grid item xs={12} sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                    }}>
                        <NoDataImg />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};


export default ReferralsDetails;